module.exports = __webpack_public_path__ + "static/img/gift-box-open.ba54afe5.png";